export const selectOrderDeliveryLimits = (state) => state.checkout.orderDeliveryLimits.data;
//# sourceMappingURL=selectOrderDeliveryLimits.js.map